import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';

import type { DuplicatePrompt } from '../../hooks/useDocuments';

interface Props {
  prompt: DuplicatePrompt | null;
  onResolve: (action: 'send-all' | 'skip-duplicates') => void;
}

/**
 * Aviso de arquivo repetido na coleção.
 *
 * Reenviar é caso legítimo: é assim que o usuário sobe uma versão nova de um
 * documento. Por isso avisa em vez de bloquear, mas avisa, porque indexar o
 * mesmo conteúdo duas vezes custa processamento e polui a resposta do
 * assistente com trecho repetido.
 */
export function DuplicateFilesDialog({ prompt, onResolve }: Props) {
  const duplicates = prompt?.duplicates ?? [];
  const freshCount = prompt?.fresh.length ?? 0;

  return (
    <AlertDialog
      open={Boolean(prompt)}
      onOpenChange={(open) => {
        if (!open) onResolve('skip-duplicates');
      }}
    >
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>
            {duplicates.length === 1
              ? 'Este arquivo já está na coleção'
              : `${duplicates.length} arquivos já estão na coleção`}
          </AlertDialogTitle>
          <AlertDialogDescription>
            Enviar de novo cria uma segunda cópia indexada, com o mesmo conteúdo.
          </AlertDialogDescription>
        </AlertDialogHeader>

        <ul className="max-h-40 space-y-1 overflow-y-auto text-sm">
          {duplicates.map((file) => (
            <li key={file.name} className="text-foreground truncate" title={file.name}>
              {file.name}
            </li>
          ))}
        </ul>

        <AlertDialogFooter>
          <AlertDialogCancel onClick={() => onResolve('skip-duplicates')}>
            {freshCount > 0 ? `Enviar só os ${freshCount} novos` : 'Cancelar'}
          </AlertDialogCancel>
          <AlertDialogAction onClick={() => onResolve('send-all')}>
            Enviar mesmo assim
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
